import { startSubmitIndicator, stopSubmitIndicator } from "../submit-indicator";

document.addEventListener('script-loaded:stripe', function () {
  if (stripe) {
    const elements = stripe.elements({
      fonts: [
        {
          family: 'Meta',
          src: 'url(https://dmxvlyap9srmn.cloudfront.net/fonts/MetaWeb-Book.woff)',
        },
      ],
    });

    const stripeCreditCardStyles = {
      base: {
        fontSize: '14px',
        fontFamily: 'Meta, sans-serif',
        color: '#96979D',
      },
      invalid: {
        color: '#EA685A',
      },
    };

    if (document.querySelector('#card-element') === null) {
      const stripePaymentForm = document.querySelector('.stripe-payment-form');
      if (stripePaymentForm) {
        const cbptEligible = stripePaymentForm.dataset.cbptEligible;
        if (cbptEligible) {
          $('.stripe-payment-form #submit').on('click', function (event) {
            event.preventDefault();
            let button = this;
            startSubmitIndicator(button);
            submitStripeForm();
          })
        }
      }
      return;
    }

    const card = elements.create('card', { style: stripeCreditCardStyles });
    card.mount('#card-element');

    card.addEventListener('change', (event) => {
      const errorContainer = document.querySelector('#card-errors');
      if (event.error) {
        errorContainer.innerText = event.error.message;
      } else {
        errorContainer.innerText = '';
      }
    });

    $('.stripe-payment-form #submit').on('click', function (event) {
      event.preventDefault();
      var button = this;
      startSubmitIndicator(button);
      stripe.createToken(card).then(function (result) {
        if (result.error) {
          // Inform the customer that there was an error.
          $('#card-errors').text(result.error.message);
          stopSubmitIndicator(button);
        } else {
          // Send the token to the server.
          submitStripeForm(result.token.id, button, 'credit_card');
        }
      });
    });
  }
});
